export default __webpack_public_path__ + "static/media/Tick.5e43caf5.svg";